import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import components from '../../components';
import SalesTable2 from '../../components/Table/SalesTable2';
import { Link,Outlet,useNavigate, useLocation, useParams } from 'react-router-dom';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';

const SalesDetails = () => {
     const navigate = useNavigate();
     const location = useLocation();
     const {id}=useParams()
     const [transetionDetails, settransetionDetails] = useState([])
     const [date, setdate] = useState("All")
     const [name, setName] = useState("");
 ;
     useEffect(() => {
       const getPurchasedDataUnit = async () => {
         if (!id) {
           toast.error("No transaction ID provided");
           return;
         }
         
         try {
           console.log("🚀 ~ Fetching data for ID:", id);
           const data = await ApiCall.SECURE_API.get(`/admin/getDataUnitsSoldByProvider/${id}?period=${date}`)
           console.log("🚀 ~ getPurchasedDataUnit ~ data:", data.data)
           
           if (data.data.success) {
             setName(data.data.providerName || 'Unknown Provider');
             settransetionDetails(data.data.data || []);
           } else {
             toast.error(data.data.message || "Failed to fetch transaction details");
           }
         } catch (error) {
           console.log("🚀 ~ getPurchasedDataUnit ~ error:", error);
           if (error?.response?.data?.message) {
             toast.error(error.response.data.message);
           } else if (error?.response?.status === 404) {
             toast.error("Provider not found");
           } else {
             toast.error("Failed to fetch transaction details");
           }
           setName('');
           settransetionDetails([]);
         }
       }
       getPurchasedDataUnit()
     }, [date, id])

     const goBack = () => {
      navigate(-1);
    }
  return (
     <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
     <div style={{ display: "flex", alignItems: "center" }}>
        <Button variant="contained"  onClick={goBack} style={{ marginRight: "20px",backgroundColor:"black" }}>
         {"< Back"}
        </Button>
        <span>
          Data & Sales Transactions: <span style={{ color: "gray" }}>{name}</span>
        </span>
      </div>  
     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                           
                            <div style={{width:"98%",marginTop:40}}>
                                <SalesTable2 transetionDetails={transetionDetails} filterState={date}/>    
                            </div>  
                            
            </div>
         
</div>
  )
}

export default SalesDetails